export const APP_TITLE_DEFAULT = 'Novti - Client Admin'
export const APP_TITLE_SUFFIX = '- Novti'

/**
 * Sets document.title from label segments plus the app suffix.
 * Empty input falls back to the default app title.
 *
 * @param {string|Array<string|null|undefined>} parts
 */
export function setDocumentTitle(parts) {
  const segments = (Array.isArray(parts) ? parts : [parts])
    .map(part => (part == null ? '' : String(part).trim()))
    .filter(Boolean)

  document.title = segments.length
    ? `${segments.join(' - ')} ${APP_TITLE_SUFFIX}`
    : APP_TITLE_DEFAULT
}
